import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar, Radio, MuiThemeProvider, createMuiTheme, withStyles, Stepper, Step, StepLabel } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from "mui-datatables";
import MuiAlert from '@material-ui/lab/Alert';
import CustomTextField from '../components/customTextField';
import NumberFormat from 'react-number-format';
import { format } from 'date-fns';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { green } from '@material-ui/core/colors';
import id from 'date-fns/locale/id/index';
import InputMask from 'react-input-mask';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable6());

const options = ct.customOptionsNofilSearch();

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

function getSteps() {
    return ['Cari Pasien', 'Selengkapnya'];
}

export default function AddPasienBaru(props) {
    const [loading, setLoading] = React.useState(false);
    const [pasien, setPasien] = useState("")
    const [noRM, setNoRM] = useState("")
    const [listDokter, setListDokter] = useState([])
    const [dokter, setDokter] = useState(null)
    const [bod, setBod] = useState(null)
    const [visibleFindPatient, setVisibleFindPatient] = React.useState(false)
    const [listPoliklinik, setListPoliklinik] = useState([])
    const [poliklinik, setPoliklinik] = useState(null)
    const [qty, setQTY] = useState("")
    const [amount, setAmount] = useState("")
    const [listPaymentOption] = useState([
        { id: 1, name: 'UMUM' },
        { id: 2, name: 'JAMINAN' },
        { id: 3, name: 'BPJS' },
    ])
    const [paymentOption, setPaymentOption] = useState(null)
    const [noKartuAsuransi, setNoKartuAsuransi] = React.useState("")
    const [pickCategory, setPickCategory] = React.useState(null)
    const [categoryInsurance, setCategoryInsurance] = React.useState([])
    const [insurance, setInsurance] = React.useState(null)
    const [listInsurance, setListInsurance] = React.useState([])
    const [namaPasienAsuransi, setNamaPasienAsuransi] = React.useState("")
    const [noRujukan, setNoRujukan] = React.useState("")
    const [namaPasienBPJS, setNamaPasienBPJS] = React.useState("")
    const [dateRujukan, setDateRujukan] = React.useState(null)
    const [noKartuBPJS, setNoKartuBPJS] = React.useState("")
    const [idPasien, setIdPasien] = useState(null)
    const [formated, setFormated] = useState("")

    const [errorPasien, setErrorPasien] = useState(false)
    const [textErrorPasien, setTextErrorPasien] = useState("")
    const [errorGender, setErrorGender] = useState(false)
    const [textErrorGender, setTextErrorGender] = useState("")
    const [errorDOB, setErrorDOB] = useState(false)
    const [textErrorDOB, setTextErrorDOB] = useState("")
    const [errorNoRM, setErrorNoRM] = useState(false)
    const [textErrorNoROM, setTextErrorNoROM] = useState("")
    const [errorPaymentOption, setErrorPaymentOption] = useState(false)
    const [textErrorPaymentOption, setTextErrorPaymentOption] = useState("")
    const [errorPoliklinik, setErrorPoliklinik] = useState(false)
    const [textErrorPoliklinik, setTextErrorPoliklinik] = useState("")
    const [errorDokter, setErrorDokter] = useState(false)
    const [textErrorDokter, setTextErrorDokter] = useState("")
    const [errorProvider, setErrorProvider] = React.useState(false)
    const [messageErrorProvider, setMessageErrorProvider] = React.useState(null)
    const [visibleMessageError, setVisibleMessageError] = React.useState(false)
    const [messageError, setMessageError] = React.useState("")

    const [visibleData, setVisibleData] = useState(false)
    const [dataVerified, setDataVerified] = React.useState([]);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);

    const listGender = [
        { value: 'Laki-laki', id: 'L' },
        { value: 'Perempuan', id: 'P' },
    ]
    const [gender, setGender] = React.useState(null)
    const [pasienGender, setPasienGender] = useState(null)

    const [manual, setManual] = useState(false)
    const [activeStep, setActiveStep] = React.useState(1);
    const [dataPasien, setDataPasien] = useState(null)
    const steps = getSteps();

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const getParam = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let idx = response.data.data.findIndex((val) => val.param_code === "MEDICAL_RECORD_NO_FORMAT")
                    console.log(idx);
                    if (idx > -1) {
                        setFormated(response.data.data[idx].param_value)
                    }
                }
            }
        })
    }

    const handleSave = () => {
        console.log(dataPasien);
        if (paymentOption === null) {
            setErrorPaymentOption(true)
            setTextErrorPaymentOption("Opsi Pembayaran Wajib Diisi")
        }
        // else if (poliklinik === null) {
        //     setErrorPoliklinik(true)
        //     setTextErrorPoliklinik("Poliklinik Wajib Diisi")
        // } else if (dokter === null) {
        //     setErrorDokter(true)
        //     setTextErrorDokter("Nama Dokter Wajib Diisi")
        // } 
        else {
            let payload = {}
            if (manual) {
                payload = {
                    name: pasien,
                    dob: bod,
                    gender: gender.id,
                    noRM: noRM,
                    payment: paymentOption,
                    doctor: dokter,
                    poli: poliklinik,
                    kategori: pickCategory,
                    asuransi: insurance,
                    noRujukan: noRujukan,
                    dateRujukan: dateRujukan,
                    noKartuAsuransi: noKartuAsuransi,
                    noKartuBPJS: noKartuBPJS,
                    namaPasienAsuransi: namaPasienAsuransi,
                    namaPasienBPJS: namaPasienBPJS,
                    manual: manual
                }
            } else {
                payload = {
                    idPasien: dataPasien[10],
                    name: dataPasien[1],
                    dob: dataPasien[3],
                    gender: dataPasien[8],
                    noRM: dataPasien[2],
                    payment: paymentOption,
                    doctor: dokter,
                    poli: poliklinik,
                    kategori: pickCategory,
                    asuransi: insurance,
                    noRujukan: noRujukan,
                    dateRujukan: dateRujukan,
                    noKartuAsuransi: noKartuAsuransi,
                    noKartuBPJS: noKartuBPJS,
                    namaPasienAsuransi: namaPasienAsuransi,
                    namaPasienBPJS: namaPasienBPJS,
                    manual: manual
                }
            }
            console.log(payload);
            props.onSubmit(payload)
        }
    }

    useEffect(() => {
        getPoliklinik()
        getCategoryInsurance()
        getParam()
    }, [])

    useEffect(() => {
        getListDokter()
    }, [poliklinik, paymentOption])

    const getCategoryInsurance = () => {
        api.create().getCategoryInsurance().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setCategoryInsurance(response.data.data)
                    forceUpdate()
                }
            }
        })
    }

    const getInsuranceByCategory = (type, code) => {
        api.create().getInsuranceByCategory(type).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setListInsurance(response.data.data)
                    let idProv = response.data.data.findIndex((val) => val.id === id)
                    if (idProv > -1) {
                        setInsurance(response.data.data[idProv])
                        forceUpdate()
                    }
                    forceUpdate()
                }
            }
            setLoading(false)
        })
    }

    const getPoliklinik = () => {
        api.create().getListMasterPoli().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item) => {
                        if (item.deleted_at === null) {
                            data.push(item)
                        }
                    })
                    setListPoliklinik(data)
                }
            }
        })
    }

    const getListDokter = () => {
        if (poliklinik) {
            let id = `&polyclinic_id=${poliklinik.id}`
            let payment = `payment_type=${paymentOption.id}`
            let param = `${payment}&${id}`
            api.create().getListDokterFilter(param).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        let data = []
                        response.data.data.map((item) => {
                            if (item.deleted_at === null) {
                                data.push(item)
                            }
                        })
                        setListDokter(data)
                    }
                }
            })

        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const handleFind = () => {
        let nama = pasien === "" ? "" : `keyword=${pasien}&filter=`
        let rm = noRM === "" ? "" : `{"medical_record_no": "${noRM}"}`
        let dob = bod === null ? "" : `{"date_of_birth": "${format(bod, 'yyyy-MM-dd')}"}`
        let params = bod === null ? `${nama}${rm}` : `${nama}${dob}`
        if (bod === null && noRM === "") {
            // setOpenAlert(true)
            // setMessageAlert("pencarian menggunakan kombinasi antara Nama Pasien dan Tanggal Lahir atau Nama Pasien dan No Rekam Medis")
            // setStatusAlert("Warning")
            setMessageError("Pencarian menggunakan kombinasi antara Nama Pasien dan Tanggal Lahir atau Nama Pasien dan No Rekam Medis")
            setVisibleMessageError(true)
            setVisibleData(false)
        } else {
            api.create().getListPatientFilter(params).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data.length > 0) {
                            let data = []
                            response.data.data.map((el) => {
                                data.push({
                                    name: el.name,
                                    rekamMedis: el.medical_record_no,
                                    bod: el.date_of_birth,
                                    ktp: el.identity_no,
                                    hp: el.phone,
                                    mobilePhone: el.mobile_phone,
                                    address: el.address,
                                    // status: "Verified",
                                    id: el.id,
                                    gender: el.gender
                                })
                            })
                            setDataVerified(data)
                            setVisibleData(true)
                        } else {
                            setOpenAlert(true)
                            setMessageAlert("Data tidak ditemukan")
                            setStatusAlert("Warning")
                            setVisibleData(false)
                        }
                    } else {
                        // if (response.data.data) {
                        //     setOpenAlert(true)
                        //     setMessageAlert(JSON.stringify(response.data.data))
                        //     setStatusAlert("Warning")
                        //     setVisibleData(false)
                        // }
                    }
                }
            })
        }
    }

    const handleClick = ({ rowData }) => {
        console.log(rowData);
        setDataPasien(rowData)
        let idx = listGender.findIndex((val) => val.id === rowData[8])
        if (idx > -1) {
            setGender(listGender[idx])
        }
        setActiveStep(activeStep + 1)
        forceUpdate()
    }

    const handleBack = () => {
        setDataPasien(null)
        setActiveStep(activeStep - 1)
        setManual(false)
        forceUpdate()
    }

    const columns = [
        {
            name: "",
            options: {
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex' }}>
                            <GreenRadio
                                title="Pilih"
                                checked={false}
                                onChange={(e) => null}
                                onClick={() => handleClick(tableMeta)}
                                // value="c"
                                name="radio"
                                style={{ padding: 0 }}
                                inputProps={{ 'aria-label': 'C' }}
                            />
                        </div>
                    )
                }
            }
        },
        {
            name: 'name',
            label: 'Nama Pasien'
        },
        {
            name: 'rekamMedis',
            label: 'No Rekam Medis'
        },
        {
            name: 'bod',
            label: 'Tanggal Lahir'
        },
        {
            name: 'ktp',
            label: 'KTP'
        },
        {
            name: 'hp',
            label: 'No Telepon'
        },
        {
            name: 'mobilePhone',
            label: 'No Handphone'
        },
        {
            name: 'address',
            label: 'Alamat'
        },
        {
            name: 'gender',
            label: 'Gender',
            // options: {
            //     display: false
            // }
        },
        {
            name: 'status',
            label: "Status",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        }
    ]

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content-full background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Input Pasien Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                {/* <Stepper alternativeLabel activeStep={activeStep}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper> */}
                {activeStep === 1 && (
                    <div>
                        <div className="grid grid-4x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                            <div className="column-1" style={{ display: 'flex' }}>
                                <TextField
                                    label={"Nama Pasien"}
                                    style={{ width: '90%', textAlign: 'left' }}
                                    helperText={textErrorPasien}
                                    error={errorPasien}
                                    onChange={(e) => {
                                        setPasien(e.target.value)
                                        setErrorPasien(false)
                                        setTextErrorPasien("")
                                        setVisibleMessageError(false)
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                            fontFamily: 'Poppins',
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-2" style={{ display: 'flex' }}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="bod"
                                        label="Tanggal Lahir"
                                        format="dd/MM/yyyy"
                                        // minDate={new Date('01-01-1901')}
                                        placeholder="Pilih tanggal lahir pasien"
                                        value={bod}
                                        error={errorDOB}
                                        helperText={textErrorDOB}
                                        onChange={(date) => {
                                            setBod(date)
                                            setErrorDOB(false)
                                            setTextErrorDOB("")
                                            setVisibleMessageError(false)
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '90%', cursor: 'pointer', margin: '2px 0' }}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            maxlength: 16
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>

                            <div className="column-3" style={{ display: 'flex' }}>
                                <Autocomplete
                                    options={listGender}
                                    getOptionLabel={(option) => option.value}
                                    onChange={(event, newInputValue) => {
                                        setGender(newInputValue)
                                        setErrorGender(false)
                                        setTextErrorGender(null)
                                        forceUpdate()
                                    }}
                                    style={{ width: '90%', marginTop: 3 }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            required={true}
                                            error={errorGender}
                                            helperText={textErrorGender}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Jenis Kelamin"
                                        />
                                    }
                                />
                            </div>

                            <div className="column-4" style={{ display: 'flex' }}>
                                <InputMask
                                    mask={String(formated).split('#').join('*')}
                                    value={noRM}
                                    onChange={(e) => {
                                        setNoRM(e.target.value)
                                        setVisibleMessageError(false)
                                    }}
                                >
                                    {() =>
                                        <TextField
                                            style={{ width: '90%', textAlign: 'left' }}
                                            label="No Rekam Medis"
                                            value={noRM}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                    fontFamily: 'Poppins',
                                                }
                                            }}
                                        />
                                    }
                                </InputMask>
                            </div>

                            {/* <div className="column-4" style={{ display: 'flex' }}>
                                <TextField
                                    // required={true}
                                    label={"No Rekam Medis"}
                                    style={{ width: '90%', textAlign: 'left' }}
                                    // error={errorQTY}
                                    // helperText={texterrorQTY}
                                    onChange={(e) => {
                                        setNoRM(e.target.value)
                                        setVisibleMessageError(false)
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                            fontFamily: 'Poppins',
                                        }
                                    }}
                                />
                            </div> */}
                        </div>
                        {visibleMessageError && (
                            <div style={{ marginTop: 20, marginBottom: 20 }}>
                                <Typography style={{ color: 'red', fontSize: 11, }}>{messageError}</Typography>
                            </div>
                        )}
                        <div className="border-top grid grid-2x" style={{ height: 56, paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                                <div
                                    onClick={(e) => {
                                        if (pasien === "") {
                                            setErrorPasien(true)
                                            setTextErrorPasien("Nama Wajib Diisi")
                                        } else if (bod === null) {
                                            setErrorDOB(true)
                                            setTextErrorDOB("Tanggal Lahir Wajib Diisi")
                                        } else if (bod === null) {
                                            setErrorDOB(true)
                                            setTextErrorDOB("Tanggal Lahir Wajib Diisi")
                                        } else if (gender === null) {
                                            setErrorGender(true)
                                            setTextErrorGender("Jenis Kelamin Wajib Diisi")
                                        } else {
                                            setManual(true)
                                            setActiveStep(activeStep + 1)
                                        }
                                    }}
                                    style={{ height: 32, width: 150, borderRadius: 20, backgroundColor: '#2a9c6c', boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <Typography style={{ color: 'white', fontSize: 15 }}>Input Pasien Baru</Typography>
                                </div>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div onClick={(e) => handleFind()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Cari Data Pasien</Typography>
                                </div>
                            </div>
                        </div>
                        {visibleData && (
                            <div style={{ height: '60vh' }}>
                                <MuiThemeProvider theme={getMuiTheme()}>
                                    <MUIDataTable
                                        data={dataVerified}
                                        columns={columns}
                                        options={options}
                                    />
                                </MuiThemeProvider>
                            </div>
                        )}
                    </div>
                )}
                {activeStep === 2 && (
                    <div>

                        <div className="grid grid-4x grid-mobile-none gap-0px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                            <div className="column-1" style={{ display: 'flex' }}>
                                <TextField
                                    disabled
                                    label={"Nama Pasien"}
                                    style={{ width: '90%', textAlign: 'left' }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                            fontFamily: 'Poppins',
                                        }
                                    }}
                                    value={dataPasien ? dataPasien[1] : pasien}
                                />
                            </div>
                            <div className="column-2" style={{ display: 'flex' }}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="bod"
                                        label="Tanggal Lahir"
                                        disabled
                                        format="dd/MM/yyyy"
                                        minDate={new Date('01-01-1901')}
                                        placeholder="Pilih tanggal lahir pasien"
                                        value={dataPasien ? new Date(dataPasien[3]) : bod}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '90%', cursor: 'pointer', margin: '2px 0' }}
                                        inputProps={{
                                            style: {
                                                fontSize: 14,
                                            },
                                            maxlength: 16
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                fontSize: 14,
                                                color: '#7e8085',
                                            }
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>

                            <div className="column-3" style={{ display: 'flex' }}>
                                <Autocomplete
                                    disabled={true}
                                    id="gender"
                                    options={listGender}
                                    getOptionLabel={(option) => option.value}
                                    style={{ width: '90%', marginTop: 5 }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            required={true}
                                            error={errorGender}
                                            helperText={textErrorGender}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Jenis Kelamin"
                                        />
                                    }
                                    value={gender}
                                />
                            </div>

                            <div className="column-4" style={{ display: 'flex' }}>
                                <TextField
                                    disabled
                                    label={"No Rekam Medis"}
                                    style={{ width: '90%', textAlign: 'left' }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                            fontFamily: 'Poppins',
                                        }
                                    }}
                                    value={dataPasien ? dataPasien[2] : noRM}
                                />
                            </div>
                            <div className="column-1" style={{ display: 'flex', marginTop: 20 }}>
                                <Autocomplete
                                    options={listPaymentOption}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, newInputValue) => {
                                        setPaymentOption(newInputValue)
                                        setErrorPaymentOption(false)
                                        setTextErrorPaymentOption(null)
                                        forceUpdate()
                                    }}
                                    style={{ width: '90%' }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            required={true}
                                            error={errorPaymentOption}
                                            helperText={textErrorPaymentOption}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Opsi Pembayaran"
                                        />
                                    }
                                />
                            </div>
                            <div className="column-2" style={{ textAlign: 'left', display: 'flex', marginTop: 20 }}>
                                <Autocomplete
                                    options={listPoliklinik}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, newInputValue) => {
                                        setPoliklinik(newInputValue)
                                        // setErrorPoliklinik(false)
                                        // setTextErrorPoliklinik(null)
                                        forceUpdate()
                                    }}
                                    style={{ width: '90%' }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            // required={true}
                                            // error={errorPoliklinik}
                                            // helperText={textErrorPoliklinik}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Poliklinik"
                                        />
                                    }
                                />
                            </div>
                            <div className="column-3" style={{ textAlign: 'left', display: 'flex', marginTop: 20 }}>
                                <Autocomplete
                                    options={listDokter}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, newInputValue) => {
                                        setDokter(newInputValue)
                                        // setErrorDokter(false)
                                        // setTextErrorDokter(null)
                                        forceUpdate()
                                    }}
                                    style={{ width: '90%' }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            // required={true}
                                            // error={errorDokter}
                                            // helperText={textErrorDokter}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                            label="Nama Dokter"
                                        />
                                    }
                                />
                            </div>
                        </div>
                        {
                            paymentOption && paymentOption.id === 2 ?
                                <div className="grid grid-4x grid-mobile-none gap-15px" style={{ paddingBottom: 20, paddingRight: 50, paddingLeft: 50 }}>
                                    <div className="column-1" style={{ display: 'flex' }}>
                                        <TextField
                                            label={"No Kartu Peserta Jaminan"}
                                            style={{ width: '90%', textAlign: 'left' }}
                                            onChange={(e) => {
                                                setNoKartuAsuransi(e.target.value)
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                    fontFamily: 'Poppins',
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="column-2">
                                        <Autocomplete
                                            style={{ width: '90%', marginTop: 4 }}
                                            options={categoryInsurance}
                                            getOptionLabel={(option) => option.type}
                                            debug
                                            value={pickCategory}
                                            onChange={(a, newInputValue) => {
                                                setLoading(true)
                                                setPickCategory(newInputValue)
                                                setInsurance(null)
                                                getInsuranceByCategory(newInputValue && newInputValue.type)
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                                    label="Kategori Provider"
                                                />
                                            }
                                        />
                                    </div>
                                    <div className="column-3">
                                        <Autocomplete
                                            style={{ width: '90%', marginTop: 4 }}
                                            options={listInsurance}
                                            disabled={pickCategory === null ? true : false}
                                            getOptionLabel={(option) => option.name}
                                            debug
                                            value={insurance}
                                            onChange={(a, newInputValue) => {
                                                setInsurance(newInputValue)
                                                // setErrorProvider(false)
                                                // setMessageErrorProvider("")
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    // required={noKartuAsuransi !== "" ? true : false}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                                    label="Provider"
                                                // error={errorProvider}
                                                // helperText={messageErrorProvider}
                                                />
                                            }
                                        />
                                    </div>
                                    <div className="column-4" style={{ display: 'flex', marginTop: 5 }}>
                                        <TextField
                                            label={"Nama Tertera Dikartu Jaminan"}
                                            style={{ width: '90%', textAlign: 'left' }}
                                            onChange={(e) => {
                                                setNamaPasienAsuransi(e.target.value)
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                    fontFamily: 'Poppins',
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                :
                                paymentOption && paymentOption.id === 3 ?
                                    <div className="grid grid-4x grid-mobile-none gap-15px" style={{ paddingBottom: 20, paddingRight: 50, paddingLeft: 50 }}>
                                        <div className="column-1" style={{ display: 'flex' }}>
                                            <TextField
                                                label={"No Rujukan"}
                                                style={{ width: '90%', textAlign: 'left' }}
                                                onChange={(e) => {
                                                    setNoRujukan(e.target.value)
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                        fontFamily: 'Poppins',
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div className="column-2" style={{ display: 'flex' }}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ margin: 0 }}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    label="Tanggal Rujukan"
                                                    // required={noRujukan !== "" ? true : false}
                                                    // error={errorDateRujukan}
                                                    // helperText={textErrorDateRujukan}
                                                    format="dd/MM/yyyy"
                                                    minDate={new Date('01-01-1901')}
                                                    value={dateRujukan}
                                                    onChange={(date) => {
                                                        setDateRujukan(date)
                                                        // setErrorDateRujukan(false)
                                                        // setTextErrorDateRujukan("")
                                                    }}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    style={{ width: '90%', cursor: 'pointer', marginTop: 0 }}
                                                    inputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                        },
                                                        maxlength: 16
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>

                                        <div className="column-3" style={{ display: 'flex' }}>
                                            <TextField
                                                label={"No Kartu BPJS"}
                                                style={{ width: '90%', textAlign: 'left' }}
                                                onChange={(e) => {
                                                    setNoKartuBPJS(e.target.value)
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                        fontFamily: 'Poppins',
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div className="column-4" style={{ display: 'flex' }}>
                                            <TextField
                                                label={"Nama Pasien BPJS"}
                                                style={{ width: '90%', textAlign: 'left' }}
                                                onChange={(e) => {
                                                    setNamaPasienBPJS(e.target.value)
                                                }}
                                                InputLabelProps={{
                                                    style: {
                                                        fontSize: 14,
                                                        color: '#7e8085',
                                                        fontFamily: 'Poppins',
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    :
                                    null
                        }

                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div onClick={() => handleBack()} style={{ height: 32, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer', marginRight: 20 }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Kembali</Typography>
                                </div>
                                <div onClick={(e) => handleSave()} style={{ height: 32, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', padding: '0 20px' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}